import React from 'react';

const AppIcon = ({ name: IconComponent, size = 24, color = 'currentColor', strokeWidth = 1, ...props }) => {
  if (typeof IconComponent === 'undefined') {
    console.error('IconComponent missing!');
    return null;
  }
  return <IconComponent size={size} color={color} strokeWidth={strokeWidth} {...props} />;
};

export default AppIcon;